import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Percent, EnvelopeSimple, FloppyDisk } from "@phosphor-icons/react";

export default function SettingsPage() {
  const [form, setForm] = useState({ max_desconto_pct: 10, admin_email: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/settings").then((r) => setForm(r.data)); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", { max_desconto_pct: Number(form.max_desconto_pct), admin_email: form.admin_email });
      toast.success("Configurações salvas.");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="settings-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-zinc-950">Configurações</h1>
        <p className="text-muted-foreground mt-1">Parâmetros gerais de emissão de pedidos.</p>
      </div>

      <Card className="p-6 shadow-none border-border space-y-6">
        <div className="flex items-start gap-4">
          <div className="h-10 w-10 rounded-md bg-accent/10 text-accent flex items-center justify-center shrink-0"><Percent size={20} weight="bold" /></div>
          <div className="flex-1 space-y-2">
            <Label className="text-sm font-semibold text-zinc-900">Limite de desconto do representante (%)</Label>
            <p className="text-xs text-muted-foreground">Pedidos com desconto acima deste limite serão bloqueados.</p>
            <Input type="number" value={form.max_desconto_pct} onChange={(e) => setForm({ ...form, max_desconto_pct: e.target.value })} className="max-w-[160px]" data-testid="settings-max-disc" />
          </div>
        </div>

        <div className="flex items-start gap-4 pt-4 border-t border-border">
          <div className="h-10 w-10 rounded-md bg-accent/10 text-accent flex items-center justify-center shrink-0"><EnvelopeSimple size={20} weight="bold" /></div>
          <div className="flex-1 space-y-2">
            <Label className="text-sm font-semibold text-zinc-900">E-mail da administração</Label>
            <p className="text-xs text-muted-foreground">Recebe cópia de todos os pedidos emitidos.</p>
            <Input value={form.admin_email} onChange={(e) => setForm({ ...form, admin_email: e.target.value })} className="max-w-md" data-testid="settings-admin-email" />
          </div>
        </div>

        <div className="pt-2">
          <Button onClick={save} disabled={saving} className="bg-accent hover:bg-accent/90 text-white gap-2" data-testid="save-settings-btn">
            <FloppyDisk size={18} weight="bold" /> {saving ? "Salvando..." : "Salvar"}
          </Button>
        </div>
      </Card>
    </div>
  );
}
